export { PhotoInputComponent } from "./photo-input.component";
export * from "./photo-input.model";
